// extracted by mini-css-extract-plugin
export var actions = "_rs-4";
export var item = "_rs-1";
export var price = "_rs-3";
export var quantity = "_rs-2";
export var table = "_rs-0";